import { render, staticRenderFns } from "./Statsionar.vue?vue&type=template&id=d6e52dc4&scoped=true"
import script from "./Statsionar.vue?vue&type=script&lang=js"
export * from "./Statsionar.vue?vue&type=script&lang=js"
import style0 from "./Statsionar.vue?vue&type=style&index=0&id=d6e52dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e52dc4",
  null
  
)

export default component.exports